var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSharpApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.112 21.97C18.0504 22.9992 16.8912 22.8367 15.7754 22.3492C14.5945 21.8508 13.5112 21.8292 12.2654 22.3492C10.7054 23.0208 9.88204 22.8258 8.95038 21.97C3.66371 16.5208 4.44371 8.2225 10.4454 7.91917C11.9079 7.995 12.9262 8.72083 13.782 8.78583C15.0604 8.52583 16.2845 7.77833 17.6495 7.87583C19.2854 8.00583 20.5204 8.65583 21.3329 9.82583C17.9529 11.8517 18.7545 16.3042 21.8529 17.55C21.2354 19.175 20.4337 20.7892 19.1012 21.9808L19.112 21.97ZM13.6737 7.85417C13.5112 5.43833 15.472 3.445 17.7254 3.25C18.0395 6.045 15.1904 8.125 13.6737 7.85417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharpApple);
export default __webpack_public_path__ + "static/media/ic_sharp-apple.b3ce52ba510f1dfee6ed7bb4fa01c257.svg";
export { ForwardRef as ReactComponent };